module.exports = __webpack_public_path__ + "static/flatart-slider-news-7e8f948e78fdb4c98f12ffdbb1d9ff46.webm";